import { render, staticRenderFns } from "./successVsFail.vue?vue&type=template&id=48c4a433&scoped=true"
import script from "./successVsFail.vue?vue&type=script&lang=js"
export * from "./successVsFail.vue?vue&type=script&lang=js"
import style0 from "./successVsFail.vue?vue&type=style&index=0&id=48c4a433&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c4a433",
  null
  
)

export default component.exports